import datacentral from '@/utils/axios/datacentral'

export const addNewTokenDevice = async (payload: {
    employee_id: number
    token_device: string
}) => {
    const response = await datacentral.post(
        '/notifications/new-token-device',
        payload
    )
    return response?.data
}

export const deleteDeviceToken = async (payload: { token_device: string }) => {
    const response = await datacentral.post(
        '/notifications/delete-token-device',
        payload
    )
    return response?.data
}
